import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { E_FR_LOC } from '@shared/constants/enums.const';
import { BUTTON_TYPES } from '@shared/components/button/button-types.enum';
import { ButtonComponent } from '@shared/components/button/button.component';
import { NgOptimizedImage } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { HelperService } from '../../../services/helper.service';
import { IFullFranchiseItem } from '@shared/constants/models.const';

@Component({
  selector: 'app-error-404',
  imports: [
    ButtonComponent,
    NgOptimizedImage,
    TranslateModule,
  ],
  templateUrl: './error-404.component.html',
  styleUrl: '../error-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Error404Component implements OnInit {
  noContent = false;
  protected readonly E_FR_LOC = E_FR_LOC;
  protected readonly BUTTON_TYPES = BUTTON_TYPES;
  HELPER: HelperService = inject(HelperService);

  get currentFrItem(): IFullFranchiseItem {
    return this.HELPER.currentFrItem;
  }

  ngOnInit(): void {
    if (this.HELPER.changeFrClicked) {
      this.noContent = true;
      this.HELPER.changeFrClicked = false;
    }
  }

  get currentTranslate() {
    return this.HELPER.currentLang;
  }

  goHome() {
    this.HELPER.goUrl('home');
  }

  mail() {
    window.location.href = 'mailto:globaliasplus@deloitte.co.uk';
  }

  changeLanguage(frLoc: E_FR_LOC) {
    this.HELPER.changeFrLoc(frLoc);
  }

}
